import type { LocalizedDict } from '../../i18n'

type AuthCopy = {
  app: {
    surface: string
    eyebrow: string
    headline: string
    body: string
    proofs: readonly string[]
  }
  admin: {
    surface: string
    eyebrow: string
    headline: string
    body: string
    proofs: readonly string[]
  }
  support: string
  terms: string
  privacy: string
  proofsLabel: string
}

export const AUTH_COPY: LocalizedDict<AuthCopy> = {
  en: {
    app: {
      surface: 'Seller & supply workspace',
      eyebrow: 'One operating system',
      headline: 'From product idea to fulfilled order.',
      body: 'Connect your catalogue, stores, production and fulfilment in one governed commerce workspace.',
      proofs: ['One catalogue', 'Clear margins', 'Governed fulfilment'],
    },
    admin: {
      surface: 'Admin workspace',
      eyebrow: 'Platform command',
      headline: 'Every operational signal. One governed view.',
      body: 'Coordinate platform operations, inventory, production and risk without losing accountability.',
      proofs: ['Live operations', 'Governed access', 'Actionable risk'],
    },
    support: 'Need help?',
    proofsLabel: 'Platform strengths',
    terms: 'Terms',
    privacy: 'Privacy',
  },
  tr: {
    app: {
      surface: 'Satıcı ve tedarik çalışma alanı',
      eyebrow: 'Tek operasyon sistemi',
      headline: 'Ürün fikrinden teslim edilen siparişe.',
      body: 'Kataloğunu, mağazalarını, üretimi ve fulfillment süreçlerini tek bir yönetilen ticaret alanında birleştir.',
      proofs: ['Tek katalog', 'Net marjlar', 'Yönetilen fulfillment'],
    },
    admin: {
      surface: 'Yönetim çalışma alanı',
      eyebrow: 'Platform komutası',
      headline: 'Tüm operasyon sinyalleri. Tek yönetilen görünüm.',
      body: 'Platform operasyonlarını, envanteri, üretimi ve riski hesap verebilirliği kaybetmeden koordine et.',
      proofs: ['Canlı operasyon', 'Yönetilen erişim', 'Aksiyona dönüşen risk'],
    },
    support: 'Yardıma mı ihtiyacın var?',
    proofsLabel: 'Platformun güçlü yanları',
    terms: 'Koşullar',
    privacy: 'Gizlilik',
  },
}
